import { FilterField } from '../../../types'

const fields: FilterField[] = [
  {
    // While transitioning from order_id to store_order_id, this search_order_id will search both order_id and store_order_id
    id: 'search_order_id',
    display: 'Order ID',
    filterTypeIds: ['contains', 'not_contains'],
  },
  {
    id: 'inserted_at',
    display: 'Date Received',
    filterTypeIds: ['date_time_in_range'],
  },
  {
    id: 'state',
    display: 'State',
    filterTypeIds: ['is'],
    options: [
      {
        display: 'Received',
        id: 'received',
      },
      {
        display: 'Open Quote',
        id: 'open_quote',
      },
      {
        display: 'Quote Denied',
        id: 'quote_denied',
      },
      {
        display: 'Processing',
        id: 'processing',
      },
      {
        display: 'Partially Shipped',
        id: 'partially_shipped',
      },
      {
        display: 'Shipped',
        id: 'shipped',
      },
      {
        display: 'Ready',
        id: 'ready_for_pickup',
      },
      {
        display: 'Cancelled',
        id: 'cancelled',
      },
      {
        display: 'Refunded',
        id: 'refunded',
      },
    ],
  },
  {
    id: 'payment_status',
    display: 'Payment Status',
    filterTypeIds: ['is'],
    options: [
      {
        display: 'Unpaid',
        id: 'unpaid',
      },
      {
        display: 'Quote Approved',
        id: 'quote_approved',
      },
      {
        display: 'Authorized',
        id: 'authorized',
      },
      {
        display: 'Cancelled',
        id: 'cancelled',
      },
      {
        display: 'Direct Pay',
        id: 'direct_pay',
      },
    ],
  },
  {
    id: 'customer',
    display: 'Customer',
    filterTypeIds: ['contains', 'not_contains', 'blank', 'not_blank'],
  },
  {
    id: 'phone_number',
    display: 'Phone Number',
    filterTypeIds: ['contains', 'not_contains'],
  },
  {
    id: 'store_name',
    display: 'Store',
    filterTypeIds: ['contains', 'not_contains', 'equals', 'not_equals'],
    adminOnly: true,
  },
  {
    id: 'gearflow_shipping',
    display: 'Gearflow Shipping',
    filterTypeIds: ['true', 'false'],
    featureFlag: 'gearflowShipping',
  },
  {
    id: 'customerIdUser',
    display: 'Customer User ID',
    filterTypeIds: ['equals'],
  },
  {
    id: 'mpn',
    display: 'MPN',
    filterTypeIds: ['contains'],
  },
  {
    id: 'purchase_order',
    display: 'Customer PO',
    filterTypeIds: ['equals'],
  },
  {
    id: 'organization_id',
    display: 'Organization',
    filterTypeIds: ['equals'],
    adminOnly: true,
  },
  {
    id: 'is_direct_pay',
    display: 'Direct Pay',
    filterTypeIds: ['true', 'false'],
    adminOnly: true,
  },
  {
    id: 'order_now',
    display: 'Order Now',
    filterTypeIds: ['true', 'false'],
  },
]

export default fields
